import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import ReportCardV2 from 'reporting-enablement/components/ReportCard/ReportCardV2';
import { TEMPLATE_CARD_HEIGHT } from '../../../components/aiSearchResults/AiSearchResultItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const TemplatePair = ({
  templates,
  singlePairs = false,
  onTemplateClick
}) => {
  if (!templates || templates.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    gap: "200",
    flexDirection: "row",
    children: templates.map(template => /*#__PURE__*/_jsx(ReportCardV2, {
      maxInlineSize: singlePairs ? '100%' : '50%',
      report: template,
      blockSize: TEMPLATE_CARD_HEIGHT,
      header: /*#__PURE__*/_jsx(Link, {
        truncate: true,
        truncateStringProps: {
          useFlex: false
        },
        onClick: () => onTemplateClick(template),
        children: template === null || template === void 0 ? void 0 : template.get('name')
      })
    }, template === null || template === void 0 ? void 0 : template.get('templateKey')))
  });
};